import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import React from "react";
import PropTypes from "prop-types";

// Filters for PassPay payouts registry based on the provided mockup
const PassPayFilter = ({ filterParam, setFilterParam, onSubmit, onClear }) => {
  const formatDate = (date) => {
    if (!date) return null;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const handleChange = (key) => (e) =>
    setFilterParam({ ...filterParam, [key]: e.target ? e.target.value : e.value });

  const handleDateChange = (fromKey, toKey) => (e) => {
    const dates = e.value;
    const update = { ...filterParam };
      console.log(update, dates);
    if (dates && dates.length > 0) {
      update[fromKey] = dates[0] ? formatDate(dates[0]) : null;
      update[toKey] = dates[1] ? formatDate(dates[1]) : null;
    } else {
      update[fromKey] = null;
      update[toKey] = null;
    }
    setFilterParam(update);
    console.log(update, dates);
  };

  // Helper to get Date objects for the Calendar component from formatted strings
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split(".");
    if (parts.length !== 3) return null;
    return new Date(parts[2], parts[1] - 1, parts[0]);
  };

  const getRangeValue = (fromKey, toKey) => {
    const from = parseDate(filterParam[fromKey]);
    const to = parseDate(filterParam[toKey]);
    if (from && to) return [from, to];
    if (from) return [from, null];
    return null;
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="p-fluid p-formgrid p-grid">
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="paymentId">ID платежа</label>
          <InputText id="paymentId" name="paymentId" value={filterParam.paymentId || ""} onChange={handleChange("paymentId")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="iin">ИИН получателя</label>
          <InputText id="iin" name="iin" value={filterParam.iin || ""} onChange={handleChange("iin")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="name">Наименование получателя</label>
          <InputText id="name" name="name" value={filterParam.name || ""} onChange={handleChange("name")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="withdrawDate">Дата платежа</label>
          <Calendar
            id="withdrawDate"
            value={getRangeValue("withdrawDateFrom", "withdrawDateTo")}
            onChange={handleDateChange("withdrawDateFrom", "withdrawDateTo")}
            selectionMode="range"
            readOnlyInput
            showIcon
            showButtonBar
            dateFormat="dd.mm.yy"
          />
          <input type="hidden" name="withdrawDateFrom" value={filterParam.withdrawDateFrom || ""} />
          <input type="hidden" name="withdrawDateTo" value={filterParam.withdrawDateTo || ""} />
        </div>
      </div>

      <div className="p-fluid p-formgrid p-grid">
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="amount">Сумма</label>
          <InputText id="amount" name="amount" value={filterParam.amount || ""} onChange={handleChange("amount")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="feeAmount">Сумма комиссии банка</label>
          <InputText id="feeAmount" name="feeAmount" value={filterParam.feeAmount || ""} onChange={handleChange("feeAmount")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="phone">Номер телефона получателя</label>
          <InputText id="phone" name="phone" value={filterParam.phone || ""} onChange={handleChange("phone")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="email">E-mail</label>
          <InputText id="email" name="email" value={filterParam.email || ""} onChange={handleChange("email")} />
        </div>
      </div>

      <div className="p-fluid p-formgrid p-grid">
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="contractNumber">Номер договора</label>
          <InputText id="contractNumber" name="contractNumber" value={filterParam.contractNumber || ""} onChange={handleChange("contractNumber")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="contractDate">Дата договора</label>
          <Calendar
            id="contractDate"
            value={getRangeValue("contractDateFrom", "contractDateTo")}
            onChange={handleDateChange("contractDateFrom", "contractDateTo")}
            selectionMode="range"
            readOnlyInput
            showIcon
            showButtonBar
            dateFormat="dd.mm.yy"
          />
          <input type="hidden" name="contractDateFrom" value={filterParam.contractDateFrom || ""} />
          <input type="hidden" name="contractDateTo" value={filterParam.contractDateTo || ""} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="operationId">Референс номер</label>
          <InputText id="operationId" name="operationId" value={filterParam.operationId || ""} onChange={handleChange("operationId")} />
        </div>
        <div className="p-field p-col-6 p-md-3">
          <label htmlFor="currency">Валюта</label>
          <InputText id="currency" name="currency" value={filterParam.currency || ""} onChange={handleChange("currency")} />
        </div>
      </div>

      <div className="p-grid p-justify-end">
        <div className="p-mr-2">
          <Button type="submit" label="Найти" autoFocus />
        </div>
        <div className="p-mr-2">
          <Button className="p-button-warning" label="Сбросить" onClick={onClear} />
        </div>
      </div>
    </form>
  );
};

PassPayFilter.propTypes = {
  filterParam: PropTypes.object.isRequired,
  setFilterParam: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default PassPayFilter;